import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppState } from 'src/store';
import { FlightLogSummaryEntity } from 'src/store/flight-log-summary/flight-log-summary.model';
import { selectFlightLogSummaryById } from 'src/store/flight-log-summary/flight-log-summary.selectors';
import { FlightLogEntity } from 'src/store/flight-log/flight-log.model';
import { selectFlightLogById } from 'src/store/flight-log/flight-log.selectors';
import { distinctUntilObjectChanged } from 'src/util/rxjs/operators';
import {
  FlightLogSummaryViewModel,
  FlightLogViewModel,
} from 'src/view-models/flight-log-view-model';

@Injectable({
  providedIn: 'root',
})
export class FlightLogViewModelService {
  constructor(private _store: Store<AppState>) {}

  public tryGetFromStore(flightLog: FlightLogEntity): Observable<FlightLogViewModel> {
    return this._store.select(selectFlightLogById(flightLog.id)).pipe(
      map((fl) => (fl != null ? fl : flightLog)),
      map((fl) => FlightLogViewModel.fromJS(fl)),
      distinctUntilObjectChanged(),
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlightLogSummaryViewModelService {
  constructor(private _store: Store<AppState>) {}

  public tryGetFromStore(flightLog: FlightLogSummaryEntity): Observable<FlightLogSummaryViewModel> {
    return this._store.select(selectFlightLogSummaryById(flightLog.id)).pipe(
      map((fl) => (fl != null ? fl : flightLog)),
      map((fl) => FlightLogSummaryViewModel.fromJS(fl)),
      distinctUntilObjectChanged(),
    );
  }
}
